// extracted by mini-css-extract-plugin
module.exports = {"Form":"CommentCreateEditForm_Form__1Qeyz","Line":"CommentCreateEditForm_Line__1aR1O","CommentsButton":"CommentCreateEditForm_CommentsButton__YZ2rz"};